import { refreshSlider } from "./programDetailSlider";

export const programCard = (root = document) => {
  const programCards = root.querySelectorAll(".js-program-card");
  if (!programCards.length) return;

  programCards.forEach((programCardElement) => {
    // 再初期化時の重複イベント防止
    if (programCardElement.dataset.programCardInitialized === "true") return;
    programCardElement.dataset.programCardInitialized = "true";

    const detailOpen = programCardElement.querySelector(
      ".js-program-card-detail-open",
    );
    const detail = programCardElement.querySelector(".js-program-card-detail");
    const detailClose = programCardElement.querySelector(
      ".js-program-card-detail-close",
    );
    if (!detailOpen || !detail || !detailClose) return;

    // CSS変数の元の値を保存
    const originalMt = getComputedStyle(programCardElement)
      .getPropertyValue("--program-open-mt")
      .trim();

    detailOpen.addEventListener("click", () => {
      detailOpen.style.opacity = "0";
      setTimeout(() => {
        detailOpen.style.display = "none";
      }, 300);

      // CSS変数を0にする
      programCardElement.style.setProperty("--program-open-mt", "0");

      detail.style.display = "block";
      setTimeout(() => {
        // 表示完了後にスライダーをリフレッシュ
        const slider = detail.querySelector(".js-program-detail-slider");
        if (slider) {
          refreshSlider(slider);
        }
      }, 300);

      detailClose.style.opacity = "1";
      setTimeout(() => {
        detailClose.style.display = "block";
      }, 300);
    });

    detailClose.addEventListener("click", () => {
      // スライダーのopacityを0に戻す
      const slider = detail.querySelector(".js-program-detail-slider");
      if (slider) {
        slider.classList.remove("is-ready");
      }

      detail.style.display = "none";

      // CSS変数を元の値に戻す
      programCardElement.style.setProperty("--program-open-mt", originalMt);

      detailOpen.style.opacity = "1";
      setTimeout(() => {
        detailOpen.style.display = "block";
      }, 300);

      detailClose.style.opacity = "0";
      setTimeout(() => {
        detailClose.style.display = "none";
      }, 300);
    });
  });
};

export default programCard;
